import{create as t}from"zustand";const a=t((t=>({t:()=>"",updateTranslate:a=>t((()=>({t:a})))})));export{a as useLocaleStore};